import { faHexagonExclamation } from '@fortawesome/pro-solid-svg-icons';

import { Alert, Button } from '@growtherapy/sprout-ui';

import { getAdultCSSRPromptText } from './utils';

type CSSRSPromptAlertProps = {
  onClose: () => void;
  patientName: string;
  onAdministerCSSRS: () => void;
  className?: string;
};

export function CSSRSPromptAlert({ onClose, patientName, onAdministerCSSRS, className }: CSSRSPromptAlertProps) {
  const text = getAdultCSSRPromptText(patientName);
  return (
    <Alert
      actions={
        <Button className='whitespace-nowrap' use='secondary' onClick={onAdministerCSSRS}>
          {text.CALL_TO_ACTION}
        </Button>
      }
      className={className}
      heading={text.HEADING}
      headingAs='h3'
      icon={faHexagonExclamation}
      use='error'
      onClose={onClose}
    >
      <span className='fs-exclude data-dd-privacy'>{`${patientName || 'Your client'}`}</span> {`${text.BODY}`}
    </Alert>
  );
}
